import { isExpertMaterialType } from './materialType';
import type { IAdminPublisherDataItemDTO } from '~/admin/shared/api/client/publishers/dto';

/*
  Картинка исходного материала для постера в публикаторах.

  У мнения эксперта запись лежит в поле expert, а не news, поэтому брать
  news?.image напрямую нельзя: у мнений постер оказывался недоступен,
  хотя картинка у материала есть. У мнения своей картинки может не быть —
  тогда подставляем фото эксперта, как на странице мнения.
*/
export const getPublisherEntryImageUrl = (
  entry: IAdminPublisherDataItemDTO | undefined | null,
): string => {
  if (!entry) {
    return '';
  }

  const { news, expert } = entry;
  const isExpert =
    isExpertMaterialType(entry.news_type) || (!news && Boolean(expert));

  const imageUrl = isExpert
    ? (expert?.image?.photo?.file_url ?? expert?.person?.photo?.file_url)
    : news?.image?.photo?.file_url;

  return typeof imageUrl === 'string' ? imageUrl : '';
};
